module.exports = __webpack_public_path__ + "3de0874649d6608a07770f38e2b08447.svg";


//////////////////
// WEBPACK FOOTER
// ./app/images/explanation-1.svg
// module id = 463
// module chunks = 0